import { projWidgetTypes } from "../_constants/widgetTypes";
import { store } from "../store";
import { fetchProjDashWidgetData } from "../_actions/dashActions";
import adrActions from "../_actions/adrActions";
import { projWidgetApiEndpoints } from "./widgetApiEndpoints";
import projActions from "../_actions/projActions";
import { actionScripts } from "./actionScripts";

/**
 * Normalized object containing the "DNA" of each widget.
 * As user picks which widgets to display, they are picked
 * out of this container and sent to the content formatter.
 * Each widget must have a dataProvider, an async function, with
 * 'projectId' as its sole param. dashActions.updateProjDashWidget
 * calls WIDGET_TYPE.dataProvider() to update the widget's
 * 'data' property.
 */
export const projWidgets = {
  [projWidgetTypes.SAFETY_COMMENTS_RAISED]: {
    widgetType: projWidgetTypes.SAFETY_COMMENTS_RAISED,
    title: "Safety Comments Raised",
    color: "bg-dash-yellow",
    bgIcon: "comments",
    dataProvider: (projectId) =>
      new Promise((resolve) =>
        store
          .dispatch(
            fetchProjDashWidgetData(
              projWidgetApiEndpoints[projWidgetTypes.SAFETY_COMMENTS_RAISED].apiEndpoint,
              projWidgetApiEndpoints[projWidgetTypes.SAFETY_COMMENTS_RAISED].params(
                projectId
              )
            )
          )
          .then((data) => resolve(data))
      ),
    viewDetailsAction: (reportParams) => actionScripts.CREATE_REPORT.run(reportParams),
    data: null,
  },
  [projWidgetTypes.ADR_STATUS]: {
    widgetType: projWidgetTypes.ADR_STATUS,
    title: "ADR Status",
    color: "",
    bgIcon: "",
    dataProvider: (projectId) =>
      new Promise((resolve) => {
        store.dispatch(adrActions.fetchSummary(projectId)).then((adrSummary) => {
          resolve(adrSummary);
        });
      }),
    viewDetailsAction: (projectId) => actionScripts.OPEN_ADR_LIST.run(projectId),
    data: null,
  },
  [projWidgetTypes.STAFF_ASSIGNMENTS]: {
    widgetType: projWidgetTypes.STAFF_ASSIGNMENTS,
    title: "Assigned Staff",
    color: "bg-dash-green",
    bgIcon: "users",
    dataProvider: (projectId) =>
      new Promise((resolve) =>
        store.dispatch(projActions.fetchAllStaff(projectId)).then(() => {
          const data = store.getState().projects.projectStaffLists[projectId].length;
          resolve(data);
        })
      ),
    viewDetailsAction: (projectId) => actionScripts.OPEN_PROJ_ASSIGNMENT.run(projectId),
    data: null,
  },
  [projWidgetTypes.PAYMENTS]: {
    widgetType: projWidgetTypes.PAYMENTS,
    title: "Payments",
    color: "bg-dash-slate",
    bgIcon: "coins",
    isApiWidget: false,
    dataProvider: () => "$1,522,073",
    data: null,
  },
};
